import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import useUniqueId from "./useUniqueId";
import ErrorPopup from "../UI/ErrorPopup/ErrorPopup";
const useErrorPopup = () => {
    const makeId = useUniqueId()[1];
    const [modals, setModals] = React.useState(
    // @ts-expect-error - TS2345 - Argument of type 'never[]' is not assignable to parameter of type '((arg1: boolean) => Node[]) | (() => (arg1: boolean) => Node[])'.
    []);
    const [modalsOpen, setModalsOpen] = React.useState([]);
    const popup = React.useCallback((message, detail = null) => {
        setModalsOpen((mO) => mO.concat([true]));
        // @ts-expect-error - TS7006 - Parameter 'm' implicitly has an 'any' type.
        setModals((m) => 
        // @ts-expect-error - TS7006 - Parameter 'open' implicitly has an 'any' type.
        m.concat((open) => (_jsx(ErrorPopup, { isOpen: open, modalId: makeId(m.length), errorMessage: message, errorDetail: detail, onModalClosed: () => {
                setModalsOpen((mO) => mO.map((isOpen, i) => (i === m.length ? false : isOpen)));
            } }, m.length))));
    }, [makeId]);
    // @ts-expect-error - TS2339 - Property 'map' does not exist on type '(arg1: boolean) => Node[]'. | TS7006 - Parameter 'modal' implicitly has an 'any' type. | TS7006 - Parameter 'index' implicitly has an 'any' type.
    return [popup, modals.map((modal, index) => modal(modalsOpen[index]))];
};
export default useErrorPopup;
